import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { updateSupportChatModuleTagAPI } from '../../../api/supportChatModuleTags';
import SupportWidgetKeys from '../../SupportWidget/queryKeys';

const { getTagsList } = SupportWidgetKeys;

const useUpdateSupportChatModuleTagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    data => {
      const { id, name, description, isActive } = data;
      return updateSupportChatModuleTagAPI({ id, name, description, isActive });
    },
    {
      onSuccess: () => {
        // Invalidate both the management table query and the filter query
        queryClient.invalidateQueries(['supportChatModuleTags']);
        queryClient.invalidateQueries([getTagsList]);
        message.success('Tag updated successfully');
      },
      onError: error => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Failed to update tag';
        message.error(errorMessage);
      },
    }
  );
};

export default useUpdateSupportChatModuleTagMutation;
